import client from '@/client/apiClient';
import User from '@/models/User/user';
import PaginatedCardCollection from '@/models/Card/paginatedCardCollection';

export default class UserService {
  static getUserBySlug(userSlug) {
    return client
      .get(`/manager/${userSlug}`, { cache: true })
      .then((response) => ({
        user: User.createFromObject(response.data),
      }));
  }

  static getUserCards(userSlug, gameWeekNumber, cursor) {
    return client
      .get(
        `/manager/${userSlug}/cards`,
        {
          cache: true,
          params: {
            gameWeek: gameWeekNumber,
            cursor: cursor
          },
        },
      )
      .then((response) => PaginatedCardCollection.createFromObject(response.data));
  }

  static updateUserSettings(email, locale) {
    return client
      .post('/settings', {
        email: email,
        locale: locale,
      });
  }
}
